import { __read } from "tslib";
import React, { useMemo, useCallback } from 'react';
import { useDebouncedState } from '@marvelapp/hooks';
import { connect } from 'react-redux';
import { serializer } from '@marvelapp/design-creator';
import LayersPanel from '../../components/handoff/LayersPanel';
import * as actionCreators from '../../actionCreators';
import { getSelectedItemUUID, isHandoffLoading } from '../../selectors';
var LayersPanelContainer = function (_a) {
    var canvas = _a.canvas, isLoading = _a.isLoading, onClose = _a.onClose, onSetHoveredId = _a.onSetHoveredId, onSetSelectedId = _a.onSetSelectedId, selectedId = _a.selectedId;
    var _b = __read(useDebouncedState(''), 3), filterText = _b[0], setFilterText = _b[1], filterInputValue = _b[2];
    var selectedIds = useMemo(function () { return [selectedId]; }, [selectedId]);
    var normalizedDesign = useMemo(function () {
        if (!canvas) {
            return null;
        }
        return serializer.normalizeCanvas(canvas);
    }, [canvas]);
    var onSelect = useCallback(function (uuid) {
        onSetSelectedId(uuid);
    }, [onSetSelectedId]);
    var onLayerMouseEnter = useCallback(function (uuid) {
        onSetHoveredId(uuid);
    }, [onSetHoveredId]);
    var onLayerMouseLeave = useCallback(function () {
        onSetHoveredId(null);
    }, [onSetHoveredId]);
    return (React.createElement(LayersPanel, { design: normalizedDesign, filterText: filterText, filterTextInputValue: filterInputValue, isLoading: isLoading, onClose: onClose, onFilterTextChange: setFilterText, onLayerMouseEnter: onLayerMouseEnter, onLayerMouseLeave: onLayerMouseLeave, onSelect: onSelect, selectedIds: selectedIds }));
};
function mapStateToProps(state) {
    return {
        canvas: state.handoff.canvas,
        isLoading: isHandoffLoading(state),
        selectedId: getSelectedItemUUID(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetSelectedId: function (uuid) {
            dispatch(actionCreators.changeHandoffSelectedItemByUUID(uuid));
        },
        onSetHoveredId: function (uuid) {
            dispatch(actionCreators.changeHandoffHoveredItemByUUID(uuid));
        },
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(LayersPanelContainer);
